import { observable, action } from "mobx";
import localForage from "localforage";
import { toast } from "react-toastify";

class CartStore {
	@observable
	items = [];

	@action
	addToCart(product, qty) {
		console.log("addToCart", product, qty);
		localForage.getItem("cart").then(cartItems => {
			const cart = Array.isArray(cartItems) ? cartItems : [];
			console.log("cartItems", cartItems, [
				...cart,
				{ ...product, productQty: product.qty, qty }
			]);
			localForage
				.setItem("cart", [
					...cart,
					{ ...product, productQty: product.qty, qty }
				])
				.then((items = []) => {
					this.items = items;
					toast.info(`Added item to cart`);
				})
				.catch(err => {
					console.error(err);
				});
		});
	}

	@action
	async removeFromCart(product, force) {
		const cartItems = await localForage.getItem("cart");
		const cart = Array.isArray(cartItems) ? cartItems : [];
		let removed = false;
		const filteredItems = cart.filter(item => {
			const acceptedItem =
				item._id !== product._id ||
				(item._id === product._id &&
					(item.days !== product.days ||
						item.selectedWaiver !== product.selectedWaiver) &&
					!force) ||
				removed;

			if (!acceptedItem) {
				removed = true;
			}
			return acceptedItem;
		});

		const items = await localForage.setItem("cart", filteredItems);

		this.items = items;
		toast.info(`Removed item from cart`);
	}

	@action
	setCart = async (cart = []) => {
		await localForage.setItem("cart", cart ? cart : []);
		this.items = cart ? cart : [];
	};

	@action
	resetCart = async () => {
		await localForage.setItem("cart", []);
		this.items = [];
	};

	@action
	async modifyItem(item, modifier) {
		const cartItems = this.items
			? this.items
			: await localForage.getItem("cart");
		const newItems = cartItems.map(cartItem =>
			cartItem._id === item._id ? { ...cartItem, ...modifier } : cartItem
		);
		localForage.setItem("cart", newItems);
		console.log("cart", newItems);
		this.items = newItems;
	}
}

const Cart = new CartStore();

export default Cart;



// WEBPACK FOOTER //
// ./src/stores/CartStore.js